"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeadingVariants = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("./styled-components");
var _excluded = ["variant", "color", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var HeadingVariants = exports.HeadingVariants = {
  140: '140',
  120: '120',
  100: '100',
  80: '80',
  60: '60',
  40: '40',
  20: '20'
};
var Heading = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? '140' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'dark' : _ref$color,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (variant) {
    case '140':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH140, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '120':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH120, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '100':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH100, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '80':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH80, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '60':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH60, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '40':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH40, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    case '20':
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH20, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
    default:
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.StyledH140, _extends({}, props, {
        color: color,
        ref: ref
      }), children);
  }
});
Heading.propTypes = {
  color: _propTypes["default"].oneOf(['light', 'white', 'dark']),
  as: _propTypes["default"].oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  id: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
Heading.displayName = 'Heading';
var _default = exports["default"] = Heading;